import { Campaign } from './campaign.model';
import { Farm } from './farm.model';
import { Point, Polygon } from './geometry.model';
import {
  CerealOutcome,
  Country,
  Destination,
  FallowAge,
  FallowType,
  PreviousCrop,
  Soil,
  SoilDepth,
  Specy,
  Variety,
} from './lists.model';

export class Parcel {
  id: number;
  name: string;
  postalCode: string;
  country: Country;
  campaign: Campaign;
  pacCode: string;
  geometry: Polygon;
  location: Point;
  area: number;
  sowedOn: string | Date;
  identifiantFms: string;
  identifiantDistributeur: string;
  farm: Farm;
  specy: Specy;
  soil: Soil;
  soilDepth: SoilDepth;
  previousCrop: PreviousCrop;
  fallowType: FallowType;
  fallowAge: FallowAge;
  cerealOutcome: CerealOutcome;
  variety: Variety;
  varietyMix: boolean;
  // pour orge pour l'instant
  destination: Destination;
  noInvoice: boolean;
  completed: boolean;

  previousParcel: Parcel;

  createdAt: string | Date;
  updatedAt: string | Date;
  active: boolean;
}

export class ParcelStatus {
  parcelId: number;
  toolStatuses: Map<string, ToolStatus>;
  countSuccessorParcels: number;
  // le sérializeur java ne sort par le is(InCurrentCampaign)
  inCurrentCampaign: boolean;
}

export interface ParcelExtra {
  weekRange?: string[];
  personalizedDate?: string;
}

export interface WeekSpan {
  weekNumber: number;
  days: Array<{ date: Date; day: number; month: string }>;
  middleMonth: string;
  middleDay: number;
  parcelIds: string[];
}

export interface ParcelDateMapping {
  [dateKey: string]: string[];
}

export interface PlanningData {
  customized_date: Array<{ date_livraison: string; parcel_ids: string }>;
  default_week: Array<{ week: number; parcel_ids: string }>;
}

export class ToolStatus {
  hasDetailsStarted: boolean;
  hasDetailsCompleted: boolean;
  hasOrder: boolean;
  orderItemId: number;
  orderId: number;
  canBeOrdered: boolean;
  canBeEdited: boolean;
  resultIds: Map<string, number>;
}
